import React from 'react';
import "./About.css";
import AboutImg from "../../assets/images/about.png";

const About = () => {
  return (
    <div className='about'>
        <div className='about-left'>
            <img src={AboutImg} alt='about' className='about-img'/>    
        </div>
        <div className='about-right'>
            <h3>About Us</h3>
            <h2>A pioneering hub for Science and Technology innovation.</h2>
            <p>Our passion lies in providing hands-on solutions that propel institutions, businesses, and enthusiasts to the forefront of scientific discovery and technological advancement. 
With a strong focus on Science and Technology, we offer customized solutions tailored to your unique needs. Our offerings include fully equipped Science Labs, interactive Science Centers, Custom Telescope Lenses, and advanced AR-VR Systems with immersive educational content. Additionally, our cutting-edge Astronomy and Astrophysics Labs serve as catalysts for exploration and experimentation, fostering groundbreaking developments in these exciting fields. Join us as we shape the future of innovation together.</p>

<p>Discover Learn Technology, your gateway to the world of Science and Technology. Specializing in hands-on solutions, we empower institutions, educators, businesses, and enthusiasts to unlock the full potential of scientific learning and technological innovation. From customized lab setups and Digital Libraries to immersive AR-VR content and precision astronomical instruments, we provide access to state-of-the-art facilities designed to inspire discovery and curiosity. With our Science Centers, Astronomy Labs, and Astrophysics Labs, we are committed to advancing education, research, and progress. Join us as we embark on a journey to shape the future of science and technology together.</p>

        </div> 
    </div>
  )
}

export default About
